import {Box, Center, Flex, Image, Text} from '@chakra-ui/react'
import VolumeIcon from '@assets/svgs/learn/volume_1.svg'
import TranslateIcon from '@assets/svgs/learn/translate.svg'
import Translate1Icon from '@assets/svgs/learn/translate_1.svg'
import {playAudio, styleByTextTag} from '@utils'
import {useEffect, useState} from 'react'
import Avatar1 from '@assets/images/learn/avatar-1.png'
import Avatar2 from '@assets/images/learn/avatar-2.png'
import appRequest from '@apis/app'

const ItemMessage = ({
  item,
  isDisableVolume,
}: {
  item: any
  isDisableVolume: boolean
}) => {
  const [extend, setExtend] = useState<any>(false)
  const [wordInfo, setWordInfo] = useState<any>(false)

  useEffect(() => {
    getWordInfo()
  }, [item])

  const getWordInfo = async () => {
    try {
      const params = {text: item?.text_en}
      const res = await appRequest.getWordInfo(params)
      setWordInfo(res.data.data)
    } catch (error) {}
  }

  const handleClickTranslate = () => {
    setExtend((pre: any) => !pre)
  }

  switch (item?.type) {
    case 'BOT_MSG':
      return (
        <Box mt={'24px'}>
          <Flex
            w={{base: '100%', md: '90%'}}
            mr={'auto'}
            gap={'12px'}
            mb={'24px'}>
            <Center
              w={{base: '32px', md: '40px'}}
              h={{base: '32px', md: '40px'}}
              bg={'#1890FF'}
              borderRadius={'50%'}
              fontWeight={700}
              color={'white'}
              flexShrink={0}
              bgImage={Avatar1}
              bgSize={'cover'}
            />
            <Box
              p={'16px'}
              borderRadius={'2px 16px 16px 16px'}
              border={'2px solid #F0F0F0'}
              sx={{
                '.vocabulary-text': {
                  color: '#FA8C16',
                },
              }}>
              <Text fontSize={'16px'} fontWeight={600}>
                <Image
                  src={VolumeIcon}
                  pointerEvents={isDisableVolume ? 'none' : 'unset'}
                  display={'inline'}
                  mb={'-4px'}
                  mr={'12px'}
                  cursor={'pointer'}
                  filter={isDisableVolume ? 'grayscale(1)' : 'unset'}
                  onClick={() => playAudio(item.audio)}
                />
                {item?.text_en}
              </Text>
              {extend && (
                <Text fontSize={'16px'} color={'#546E7A'} mt={'8px'}>
                  {wordInfo ? wordInfo?.text_vi : 'loading...'}
                </Text>
              )}
            </Box>
            <Flex alignItems={'center'} flexShrink={0}>
              <Image
                w={{base: '32px', md: '40px'}}
                src={extend ? TranslateIcon : Translate1Icon}
                cursor={'pointer'}
                bg={extend ? '#FFF7E6' : 'white'}
                p={'10px'}
                border={extend ? 'unset' : '1px solid #F0F0F0'}
                borderRadius={'50%'}
                onClick={handleClickTranslate}
              />
            </Flex>
          </Flex>
        </Box>
      )
    case 'USER_MSG':
      return (
        <Flex
          w={{base: '100%', md: '90%'}}
          ml={'auto'}
          justifyContent={'end'}
          gap={'12px'}
          mb={'24px'}>
          <Flex alignItems={'center'} flexShrink={0}>
            <Image
              src={extend ? TranslateIcon : Translate1Icon}
              w={{base: '32px', md: '40px'}}
              cursor={'pointer'}
              border={extend ? 'unset' : '1px solid #F0F0F0'}
              p={'10px'}
              bg={extend ? '#FFF7E6' : 'white'}
              borderRadius={'50%'}
              onClick={handleClickTranslate}
            />
          </Flex>
          <Box
            p={'16px'}
            borderRadius={'16px 2px 16px 16px'}
            border={'2px solid #F0F0F0'}
            sx={{
              '.vocabulary-text': {
                color: '#FA8C16',
              },
            }}>
            <Text
              fontSize={'16px'}
              fontWeight={600}
              sx={{
                '.vocabulary-text': {color: '#45BB66'},
                '.practice-sentence': {
                  color: 'red',
                },
              }}>
              {styleByTextTag(item?.text_en)}
            </Text>
            {extend && (
              <Text
                fontSize={'16px'}
                color={'#546E7A'}
                mt={'8px'}
                sx={{
                  '.vocabulary-text': {color: '#45BB66'},
                  '.practice-sentence': {
                    color: 'red',
                  },
                }}>
                {wordInfo ? styleByTextTag(wordInfo?.text_vi) : 'loading...'}
              </Text>
            )}
          </Box>
          <Center
            w={{base: '32px', md: '40px'}}
            h={{base: '32px', md: '40px'}}
            bg={'#1890FF'}
            borderRadius={'50%'}
            fontWeight={700}
            color={'white'}
            flexShrink={0}
            bgImage={Avatar2}
            bgSize={'cover'}
          />
        </Flex>
      )
    default:
      return (
        <Flex
          w={{base: '100%', md: '90%'}}
          ml={'auto'}
          justifyContent={'end'}
          gap={'12px'}
          mb={'24px'}>
          <Flex alignItems={'center'} flexShrink={0}>
            {item?.type != 'FILL_MSG' && (
              <Image
                src={extend ? TranslateIcon : Translate1Icon}
                w={{base: '32px', md: '40px'}}
                cursor={'pointer'}
                border={extend ? 'unset' : '1px solid #F0F0F0'}
                p={'10px'}
                bg={extend ? '#FFF7E6' : 'white'}
                borderRadius={'50%'}
                onClick={handleClickTranslate}
              />
            )}
          </Flex>
          <Box
            p={'16px'}
            borderRadius={'16px 2px 16px 16px'}
            border={'2px solid #F0F0F0'}
            sx={{
              '.vocabulary-text': {
                color: '#FA8C16',
              },
            }}>
            {item?.type === 'SUGGEST_MSG' && (
              <Text
                mb={'8px'}
                fontSize={'14px'}
                textTransform={'uppercase'}
                color={'#8C8C8C'}>
                Hãy thử nói
              </Text>
            )}
            <Text fontSize={'16px'} fontWeight={600}>
              {item?.text_en}
            </Text>
            {extend && (
              <Text fontSize={'16px'} color={'#546E7A'} mt={'8px'}>
                {wordInfo ? wordInfo?.text_vi : 'loading...'}
              </Text>
            )}
          </Box>
          <Center
            w={{base: '32px', md: '40px'}}
            h={{base: '32px', md: '40px'}}
            bg={'#1890FF'}
            borderRadius={'50%'}
            fontWeight={700}
            color={'white'}
            flexShrink={0}
            bgImage={Avatar2}
            bgSize={'cover'}
          />
        </Flex>
      )
  }
}
export default ItemMessage
